import PropTypes from 'prop-types';

/** Two overlapping pages; the filled one is the side drawn on top (0 left, 1 right). */
export default function SpreadLayerIcon({ onTop = 1, className = 'w-4 h-4' }) {
    const back = onTop === 0 ? { x: 9, y: 8 } : { x: 4, y: 5 };
    const front = onTop === 0 ? { x: 4, y: 5 } : { x: 9, y: 8 };
    return (
        <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} aria-hidden="true">
            <rect x={back.x} y={back.y} width="11" height="11" rx="1.5" />
            <rect x={front.x} y={front.y} width="11" height="11" rx="1.5" fill="currentColor" />
        </svg>
    );
}

SpreadLayerIcon.propTypes = {
    onTop: PropTypes.oneOf([0, 1]),
    className: PropTypes.string,
};
